import { render, staticRenderFns } from "./Fattutto.vue?vue&type=template&id=da911c86&"
import script from "./Fattutto.vue?vue&type=script&lang=js&"
export * from "./Fattutto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports